import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AdminService from "../../services/AdminService";
import ErrorModal from "../../component/ErrorModal";

const AdminProfile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [userInfo, setUserInfo] = useState({
    bin: "",
    organizationName: "",
    iin: "",
    fio: "",
    role: "",
    adminId: "",
    adminEmail: "",
    developerEmail: "",
  });
  const [editing, setEditing] = useState({
    adminEmail: false,
    developerEmail: false,
  });
  const [newEmails, setNewEmails] = useState({
    adminEmail: "",
    developerEmail: "",
  });

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await AdminService.getAdminProfile();
      const devEmailResponse = await AdminService.getDevEmail();
      setUserInfo({
        bin: response.data.bin,
        organizationName: response.data.organizationName,
        iin: response.data.iin,
        fio: response.data.fio,
        role: response.data.role,
        adminId: response.data.id,
        adminEmail: response.data.adminEmail,
        developerEmail: response.data.developerEmail,
        // developerEmail: devEmailResponse?.data.developerEmail,
        // developerEmail: devEmailResponse?.data?.developerEmail || "Почта не указана",
      });
    } catch (error) {
      if (error.response?.status === 403) {
        navigate("/nm-auth", { replace: true });
      } else {
        console.error("Ошибка при загрузке данных", error);
      }
    }
  };

  const handleEmailEdit = (emailType) => {
    setEditing((prev) => ({ ...prev, [emailType]: true }));
    setNewEmails((prev) => ({ ...prev, [emailType]: userInfo[emailType] })); 
    setErrorMessage(null);
  };

  const handleCancelEdit = (emailType) => {
    setEditing((prev) => ({ ...prev, [emailType]: false }));
  };

  

  const handleEmailSave = async (emailType) => {
    const emailValue = newEmails[emailType];
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(emailValue)) {
      setErrorMessage(t("error.adminEmailError"));
      return;
    }

    try {
      const serviceMethod =
        emailType === "adminEmail"
          ? AdminService.postAdminEmail
          : AdminService.postDevEmail;
      const response = await serviceMethod(emailValue);
      setErrorMessage(null);
      setUserInfo((prev) => ({
        ...prev,
        [emailType]: response.data,
      }));
      setEditing((prev) => ({ ...prev, [emailType]: false }));
    } catch (error)  {
      if (error.response?.status === 400) {
        setErrorMessage("Отправлено пустое поле");
      } else {
        setErrorMessage("Произошла ошибка при сохранении email"); // Общее сообщение об ошибке
      }
      console.error("Ошибка при сохранении email", error);
    }
  };

  const handleInputChange = (emailType, value) => {
    setNewEmails((prev) => ({ ...prev, [emailType]: value }));
  };

  const getButtonLabel = (email) =>
    email ? t("NCALayerModuleForm.adminChangeButton") : t("NCALayerModuleForm.adminAddButton");

  return (
    <div className="content">
      <div className="titleCell">
        <span>{t("NCALayerModuleForm.profile")}</span>
      </div>
      <form id="indexForm" className="indexForm">
      {errorMessage && <ErrorModal errorMessage={errorMessage} />}
        <table className="infoPanelGrid" cellPadding="8">
          <thead>
            <tr>
              <th className="vktHeader" colSpan="3">
                {t("general.userData")}
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(userInfo)
              .filter(([key]) => key !== "adminEmail" && key !== "developerEmail" && key !== "adminId")
              .map(([key, value], index) => (
                <tr key={index}>
                  <td className="ccLeft width-255">
                    <span className="info-label-right">
                      {t(`SDKUserForm.${key}`)}:
                    </span>
                  </td>
                  <td className="ccRight">{value}</td>
                  <td className="ccRight"></td>
                </tr>
              ))}
    
            {["adminEmail", "developerEmail"].map((emailType) => (
              <tr key={emailType}>
                <td className="ccLeft width-255">
                  <span className="info-label-right">
                    {t(`NCALayerModuleForm.${emailType}`)}:
                  </span>
                </td>
                <td className="ccRight">
                  {editing[emailType] ? (
                    <input
                      type="email"
                      value={newEmails[emailType]}
                      onChange={(e) =>
                        handleInputChange(emailType, e.target.value)
                      }
                      className={`nm-input ${editing[emailType] ? "editing" : ""}`}
                    />
                  ) : (
                    userInfo[emailType]
                  )}
                </td>
                <td className="ccRight">
                  {editing[emailType] ? (
                    <>
                      <input
                        type="button"
                        onClick={() => handleEmailSave(emailType)}
                        value={t("NCALayerModuleForm.adminSaveButton")}
                        className="new-blue-btn"
                      />
                      <input
                        type="button"
                        style={{marginLeft: "5px"}}
                        onClick={() => handleCancelEdit(emailType)}
                        value={t("general.cancel")}
                        className="new-red-btn" // кнопка отмены
                      />
                    </>
                  ) : (
                    <input
                      type="button"
                      onClick={() => handleEmailEdit(emailType)}
                      value={getButtonLabel(userInfo[emailType])}
                      className="new-blue-btn"
                    />
                  )}
                </td>
              </tr>
            ))}
               
          </tbody>
        </table>
      </form>
    </div>
  );
};

export default AdminProfile;
